import { createFileRoute, Link } from '@tanstack/react-router'
import { Landmark, Wallet } from 'lucide-react'
import type { ReactElement } from 'react'

/**
 * `/admin/finance` (index) — Overview. Content beyond the entry card into
 * Chart of Accounts Templates is out of scope until more Finance sub-surfaces land.
 */
export const Route = createFileRoute('/admin/finance/')({
  component: FinanceOverviewPage,
})

function FinanceOverviewPage(): ReactElement {
  return (
    <div className="ka-page">
      <header className="ka-page-header">
        <div>
          <h1 className="ka-page-header-title">Finance</h1>
          <p className="ka-page-header-subtitle">Platform-level finance reference data.</p>
        </div>
      </header>

      <div className="ka-card">
        <div className="ka-empty">
          <div className="ka-empty-icon">
            <Wallet size={20} aria-hidden="true" />
          </div>
          <div className="ka-empty-title">Chart of Accounts Templates</div>
          <p className="ka-empty-body">
            Manage the reference account-list templates entities pick from
            when onboarding — one per country, with manual entry or Excel
            import.
          </p>
          <Link to="/admin/finance/reference-accounts" className="ka-btn ka-btn--primary ka-btn--sm">
            <Landmark size={14} aria-hidden="true" /> Open Chart of Accounts Templates
          </Link>
        </div>
      </div>
    </div>
  )
}
